import { Card, Group, Table, useTable } from '@melio/penny';
import { useCollaborators } from '@melio/platform-api';
import { noop } from 'lodash';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';

import { CreateCollaboratorDrawerActivity, EditCollaboratorDrawerActivity } from '../../collaborator-drawer';
import { CardHeader } from './components/CardHeader';
import { useCollaboratorsTableColumns } from './useCollaboratorsTableColumns';

export const CollaboratorsActivity = () => {
  const navigate = useNavigate();

  const { data: collaborators, isLoading: isCollaboratorsLoading } = useCollaborators({ expand: ['user'] });

  const columns = useCollaboratorsTableColumns();
  const tableProps = useTable({
    isHeaderSticky: true,
    headerVariant: 'dark',
    isLoading: isCollaboratorsLoading,
    data: collaborators ?? [],
    onRowClick: ({ rowData: { id } }) => navigate(`${id}`),
    columns,
  });

  return (
    <>
      <Card paddingX="l" paddingY="xl" variant="flat">
        <Group variant="vertical" spacing="m" width="full">
          <Group.Item>
            <CardHeader onAddCollaboratorClick={() => navigate('new')} />
          </Group.Item>
          <Group.Item>
            <Table {...tableProps} />
          </Group.Item>
        </Group>
      </Card>

      <Routes>
        <Route path=":collaboratorId" element={<EditCollaboratorDrawerActivityWithCollaboratorId onClose={noop} />} />
        <Route path="new" element={<CreateCollaboratorDrawerActivity onClose={noop} />} />
      </Routes>
    </>
  );
};

const EditCollaboratorDrawerActivityWithCollaboratorId = ({ onClose }: { onClose: VoidFunction }) => {
  const { collaboratorId } = useParams();
  return collaboratorId ? <EditCollaboratorDrawerActivity collaboratorId={collaboratorId} onClose={onClose} /> : null;
};
